/* eslint-disable @typescript-eslint/naming-convention */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ElementController } from './ElementController.js';
import { CustomElement, OnEvent, Attribute } from '../utils/CustomElement.js';
import { Observable } from '../../../Observable.js';
import { assert } from '../../../babylon/utility/Assert.js';
export var TransfomTool;
(function (TransfomTool) {
    TransfomTool["SELECT"] = "select";
    TransfomTool["MOVE"] = "move";
    TransfomTool["ROTATE"] = "rotate";
    TransfomTool["SCALE"] = "scale";
})(TransfomTool || (TransfomTool = {}));
export var TransformationOrientation;
(function (TransformationOrientation) {
    TransformationOrientation["GLOBAL"] = "GLOBAL";
    TransformationOrientation["LOCAL"] = "LOCAL";
})(TransformationOrientation || (TransformationOrientation = {}));
var Events;
(function (Events) {
    Events["ACTIVE_CHANGED"] = "active_changed";
    Events["ORIENTATION_CHANGED"] = "orientation_changed";
})(Events || (Events = {}));
const DEBUG_TRANSFORM_BAR = 'debug-transform-bar';
let DebugTransformBar = class DebugTransformBar extends HTMLElement {
    constructor() {
        super();
        this._available_tools = new Set([TransfomTool.SELECT]);
        this._show_orientation_switch = false;
        this._orientation = TransformationOrientation.GLOBAL;
        this.x = '10';
        this.y = '80';
        this.active = TransfomTool.SELECT;
        this._shadow = this.attachShadow({ mode: 'open' });
        this.render();
    }
    get use_global_transform() {
        return this._orientation === TransformationOrientation.GLOBAL && this._show_orientation_switch;
    }
    set_available_tools(value, show_orientation_switch) {
        this._available_tools = new Set(value);
        this._available_tools.add(TransfomTool.SELECT);
        this._show_orientation_switch = show_orientation_switch;
        if (!this._available_tools.has(this.active)) {
            this.setAttribute('active', TransfomTool.SELECT);
        }
        else {
            this.render();
        }
    }
    attributeChangedCallback(name, old_value, new_value) {
        if (name === 'active' && old_value !== new_value) {
            this.dispatchEvent(new CustomEvent(Events.ACTIVE_CHANGED, { detail: new_value }));
        }
    }
    on_select_click() {
        this.setAttribute('active', TransfomTool.SELECT);
    }
    on_move_click() {
        this.setAttribute('active', TransfomTool.MOVE);
    }
    on_rotate_click() {
        this.setAttribute('active', TransfomTool.ROTATE);
    }
    on_scale_click() {
        this.setAttribute('active', TransfomTool.SCALE);
    }
    on_orientation_change(e) {
        const checkbox = e.target;
        if (checkbox.checked) {
            this._orientation = TransformationOrientation.LOCAL;
        }
        else {
            this._orientation = TransformationOrientation.GLOBAL;
        }
        const text = this._shadow.querySelector('.text');
        assert(text, 'Text element should exist');
        text.innerHTML = this._orientation;
        this.dispatchEvent(new CustomEvent(Events.ORIENTATION_CHANGED, { detail: this._orientation }));
    }
    get_class(tool) {
        let class_string = tool === this.active ? `${tool} active` : tool;
        if (!this._available_tools.has(tool)) {
            class_string += ' disabled';
        }
        return class_string;
    }
    render() {
        this._shadow.innerHTML =
            /* html */
            `
      <style>
        :host {
          display: flex;
          position: absolute;
          z-index: 9001;
          left: ${this.x}px;
          top: ${this.y}px;
          box-sizing: border-box;
          align-items: center;
          justify-content: center;
          padding: 10px;
          background-color: #ffffff00;
          border-radius: 8px;
          pointer-events: auto;

          transition-property: background-color;
          transition-duration: 0.2s;
          transition-timing-function: ease-in-out ;
        }
        :host(:hover) {
          background-color: #ffffff3d;
        }
        .tool {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          width: 40px;
          margin: 6px;
          border-radius: 8px;
          background-color: #a5a5de;
          cursor: pointer;
        }
        .tool:hover {
          background-color: #f15c5c;
        }
        .active {
          background-color: #7878a5;
        }
        .active:hover {
          background-color: #da4444;
        }
        .disabled {
          display: none;
        }
        .switch-container {
          display: ${this._show_orientation_switch ? 'flex' : 'none'};
          flex-direction: column;
          margin: 6px;
          margin-top: 12px;
        }
        .switch {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 20px;
        }
        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #a5a5de;
          transition: .4s;
          border-radius: 34px;
        }
        .slider:before {
          position: absolute;
          content: "";
          height: 14px;
          width: 14px;
          left: 4px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }
        input:checked + .slider {
          background-color: #7878a5;
        }
        input:checked + .slider:before {
          transform: translateX(18px);
        }
        .text {
          color: #7878a5;
          font-size: 9px;
          font-weight: 800;
        }
        input:checked ~ .text {
          left: 6px;
          right: auto;
        }
      </style>
      <div class="container">
        <div class="tool ${this.get_class(TransfomTool.SELECT)}">↗</div>
        <div class="tool ${this.get_class(TransfomTool.MOVE)}">⮂</div>
        <div class="tool ${this.get_class(TransfomTool.ROTATE)}">↻</div>
        <div class="tool ${this.get_class(TransfomTool.SCALE)}">◱</div>

        <div class="switch-container"> 
          <label class="switch">
          <input type="checkbox" ${this._orientation === TransformationOrientation.LOCAL ? 'checked' : ''}>
            <span class="slider"></span>
          </label>
          <span class="text">${this._orientation}</span>
        </div>
      </div>
    `;
    }
};
__decorate([
    Attribute
], DebugTransformBar.prototype, "x", void 0);
__decorate([
    Attribute
], DebugTransformBar.prototype, "y", void 0);
__decorate([
    Attribute
], DebugTransformBar.prototype, "active", void 0);
__decorate([
    OnEvent('click', `.${TransfomTool.SELECT}`)
], DebugTransformBar.prototype, "on_select_click", null);
__decorate([
    OnEvent('click', `.${TransfomTool.MOVE}`)
], DebugTransformBar.prototype, "on_move_click", null);
__decorate([
    OnEvent('click', `.${TransfomTool.ROTATE}`)
], DebugTransformBar.prototype, "on_rotate_click", null);
__decorate([
    OnEvent('click', `.${TransfomTool.SCALE}`)
], DebugTransformBar.prototype, "on_scale_click", null);
__decorate([
    OnEvent('change', 'input')
], DebugTransformBar.prototype, "on_orientation_change", null);
DebugTransformBar = __decorate([
    CustomElement(DEBUG_TRANSFORM_BAR)
], DebugTransformBar);
export class DebugTransformBarController extends ElementController {
    constructor(parent) {
        super(parent, DEBUG_TRANSFORM_BAR);
        this.observables = {
            on_active_changed: new Observable(),
            on_orientation_changed: new Observable()
        };
        this._element.addEventListener(Events.ACTIVE_CHANGED, (e) => {
            const event = e;
            this.observables.on_active_changed.notify(this, event.detail);
        });
        this._element.addEventListener(Events.ORIENTATION_CHANGED, (e) => {
            const event = e;
            this.observables.on_orientation_changed.notify(this, event.detail);
        });
    }
    set_available_tools(tools, show_orientation_switch) {
        this._element.set_available_tools(tools, show_orientation_switch);
    }
    get active() {
        var _a;
        return (_a = this.get_attribute('active')) !== null && _a !== void 0 ? _a : '';
    }
    set active(value) {
        this.set_attribute('active', value);
    }
    get use_global_transform() {
        return this._element.use_global_transform;
    }
}
//# sourceMappingURL=DebugTransformBar.js.map